/**
 * Test IDs for QA automation.
 */
export const testIds = {
  lynksTabsNavigation: "lynks-tabs-navigation",
} as const;
